"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("lodash/values"));
var _localityType = _interopRequireDefault(require("../enums/locality-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var resolveLocalityTypeFromSlug = slug => slug && (0, _values.default)(_localityType.default).find(type => type.slugPattern && slug.match(type.slugPattern)) || null;
var _default = exports.default = resolveLocalityTypeFromSlug;